


































import { Component, Vue, Prop, Emit } from 'vue-property-decorator';
import { UPDATE_PRODUCT_GROUP } from './updateProductGroup';
import { GET_PRODUCT_GROUP } from './getProductGroup';
import ProductGroupForm from '@/components/ProductGroup/ProductGroupForm.vue';
import { InMemoryCache } from 'apollo-cache-inmemory';
import { GQL_updateProductGroup } from '@/queries/__generated__/updateProductGroup';
import { GQL_ProductGroupUpdate } from '@/queries/global';

@Component({
  components: {
    ProductGroupForm,
  },
})
export default class ProductGroupEdit extends Vue {
  @Prop([ Number, String ]) private id!: number | string;
  private GET_PRODUCT_GROUP = GET_PRODUCT_GROUP;
  private UPDATE_PRODUCT_GROUP = UPDATE_PRODUCT_GROUP;

  @Emit()
  private productGroupUpdated(store: InMemoryCache, query: { data: GQL_updateProductGroup }) {
    return query.data.updateProductGroup && query.data.updateProductGroup.productGroup;
  }

  public formatForMutation(productGroup: GQL_ProductGroupUpdate): GQL_ProductGroupUpdate {
    return {
      id: productGroup.id,
      name: productGroup.name,
      description: productGroup.description,
      parentGroupId: productGroup.parentGroupId,
    };
  }
}
